import { useState } from 'react';
import styled from 'styled-components';
import { Link, withRouter } from 'react-router-dom';

import { infoModalDataState, useRecoilState } from '../../../../store';

import { EInfoModal } from '@/components/ticketingNew/components/InfoModal';
import TicketItemMobile from '@/components/ticketingNew/components/TicketItemMobile';
import OrderDetailsBlock from '@/components/ticketingNew/components/OrderDetailsBlock';
import { OrderStageEnum } from '@/components/ticketingNew/pages/Order';
import OrderSuccess from '@/components/ticketingNew/pages/OrderSuccess';

const MainWrap = styled.div`
  border-radius: 20px;
  width: 1162px;
  max-width: 100%;
  margin: 44px auto 43px auto;
  background: rgba(79, 79, 79, 0.6);
  backdrop-filter: blur(150px);
  padding: 54px 180px;
  color: white;
  position: relative;
  text-align: center;

  .otft-home {
    font-weight: 600;
    font-size: 18px;
    color: white;
    text-decoration: none;
    position: absolute;
    left: 65px;
    top: 69px;

    i {
      margin-right: 5px;
    }
  }

  .otft-header {
    font-weight: 400;
    font-size: 60px;
    line-height: 90px;
    margin-bottom: 10px;
  }

  .otft-title {
    font-weight: 500;
    font-size: 22px;
    line-height: 33px;
    margin-bottom: 10px;
  }

  .otft-message {
    font-weight: 400;
    font-size: 20px;
    line-height: 30px;
    margin-bottom: 40px;
  }

  .otft-content {
    display: flex;
  }

  .otft-tickets {
    color: black;
    width: 50%;

    max-height: 435px;
    overflow-y: scroll;
    padding-right: 5px;
  }
  .otft-payment {
    text-align: initial;
    width: 50%;

    .bl-ticket-order {
      width: 100%;
      padding: 28px;
      color: black;
      margin-left: 15px;
    }

    .bl-ticket-order-pay-btn {
      padding: 8px 15px;
      width: 100%;
    }
  }
`;

const OrderTicketFromTour = (props: any) => {
  const { location, message = 'Your ticket time is expired.. but you can buy a new ticket', match } = props;
  const [infoModalData, setInfoModalData] = useRecoilState(infoModalDataState);
  console.log('infoModalData', infoModalData);
  const { ticketing, ticketingOrderedTicket, ticketingTourTicket, tour } = infoModalData?.ticketLoginData;
  const participants = [
    {
      id: Date.now(),
      fullName: ticketingOrderedTicket.name,
      email: ticketingOrderedTicket.email,
      isGift: ticketingOrderedTicket.isGift,
    },
  ];
  const [pickedTicketId, setPickedTicketId] = useState<number | null>(null);
  const [orderLink, setOrderLink] = useState('');
  const [orderStage, setOrderStage] = useState(OrderStageEnum.order);

  const homePage = location.pathname.replace(/book.+|book/g, '');

  const closeInfoModal = () => setInfoModalData({ ...infoModalData, isOpen: false });

  const getTicketList = () => {
    //get current orderedTicket data & return tickets of same type (guided, ys, experience)
    //for restriction, return tours that have access to restricted sweep
    if (ticketingOrderedTicket.ticketType === 'gameTour') return ticketing?.ticketingGameTour;
    else if (ticketingOrderedTicket.ticketType === 'tourByYourself') return ticketing?.ticketingToursByYourself;
    else if (ticketingOrderedTicket.ticketType === 'guidedTour') return ticketing?.ticketingGuidedTour;
    return [];
  };
  //@ts-ignore
  const handlePaymentSuccess = () => {
    //close modal
    //go to login page with inserted ticket id
  };

  const tickets = getTicketList();

  console.log('tickets', tickets);
  console.log('infoModalData', infoModalData);

  if (!tickets || !infoModalData) {
    setInfoModalData({
      ...infoModalData,
      mode: EInfoModal.error,
      message: infoModalData.mode === EInfoModal.timeIsUp ? 'Ticket time is up' : 'Area is restricted for this tour',
    });
    return <div>closing...</div>;
  }

  console.log('ticketingOrderedTicket', ticketingOrderedTicket);
  console.log('ticketingTourTicket', ticketingTourTicket);
  return (
    <MainWrap>
      {orderStage === OrderStageEnum.order && (
        <>
          <Link to={homePage} className="otft-home" onClick={closeInfoModal}>
            <i className="fas fa-chevron-left" />
            Home Page
          </Link>
          <div className="otft-header">Oops!</div>
          <div className="otft-title">{message}</div>
          <div className="otft-message">Pick your new ticket</div>
          <div className="otft-content">
            <div className="otft-tickets">
              {tickets?.map((e) => (
                <TicketItemMobile key={e?.id} ticket={e} currencyId={3} onPick={(id: number) => setPickedTicketId(id)} pickedId={pickedTicketId} />
              ))}
            </div>
            <div className="otft-payment">
              <OrderDetailsBlock
                tourId={tour?.id}
                gameId={tour?.gameId}
                matterId={tour?.matterId}
                setOrderStage={setOrderStage}
                participants={participants}
                handlePaymentSuccess={() => setOrderStage(OrderStageEnum.tourOrderOnlySuccess)}
                match={match}
                setOrderLink={setOrderLink}
                initialTourType={ticketingOrderedTicket?.ticketType}
                initialTicketId={pickedTicketId}
              />
            </div>
          </div>
        </>
      )}
      {orderStage === OrderStageEnum.payment && (
        <div className="otft-order-frame">
          <div>
            <i className="fas fa-chevron-left" /> back
          </div>
          <div>Payment</div>
          <div>Please enter your payment details</div>
          <iframe src={orderLink} />
        </div>
      )}
      {orderStage === OrderStageEnum.tourOrderOnlySuccess && <OrderSuccess minimized={true} onLinkClick={closeInfoModal} />}
    </MainWrap>
  );
};

export default withRouter(OrderTicketFromTour);
